import { render, staticRenderFns } from "./SingleSignOnSection.vue?vue&type=template&id=1278819e"
import script from "./SingleSignOnSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSignOnSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports